import ServiceFactory from './service-factory';

export default class BusinessServiceFactory extends ServiceFactory {
  // eslint-disable-next-line
  constructor(...args) {
    // noinspection JSCheckFunctionSignatures
    super(...args);
  }
}
